import socket from "services/sockets/socket";
import store from "services/store";
import { setSocketConnection } from "actions";

/**
 */
export default function() {
  socket.connection.bind("connected", () => {
    store.dispatch(setSocketConnection(true));
  });

  socket.connection.bind("disconnected", () => {
    store.dispatch(setSocketConnection(true));
  });
}
